var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-search-section-self-services",attrs:{"id":_vm.id}},[_c('div',{class:[
			'grid gap-layout-gutter',
			'grid-cols-1 >=768:grid-cols-2 >=1024:grid-cols-3',
		]},_vm._l((_vm.items),function(item,index){return _c('ContentCard',{key:`item-${index}`,attrs:{"title":item.name,"teaser":item.teaser,"link":{ url: item.url }},scopedSlots:_vm._u([(item && item.targetGroups)?{key:"before",fn:function(){return [_c('span',{staticClass:"font-darker-grotesque font-semibold",domProps:{"innerHTML":_vm._s(item.targetGroups[0])}})]},proxy:true}:null,{key:"after",fn:function(){return [_c('div',{staticClass:"flex items-center space-x-12 mt-lg"},[_c('div',{class:[
							'c-search-section-page__button',
							'flex items-center justify-center',
							'w-24 h-24 rounded-full border-black',
							{
								'bg-black  text-white':
									_vm.computedExternal[index],
							},
						]},[_c('SvgArrow',{class:[
								'w-12',
								{
									'transform -rotate-45':
										_vm.computedExternal[index],
								},
							]})],1),_vm._v(" "),_c('span',{class:[
							'font-bold font-darker-grotesque',
							'uppercase text-button-xs',
						],domProps:{"textContent":_vm._s('Læs mere')}})])]},proxy:true}],null,true)})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }